import { call, put, takeLatest, all } from 'redux-saga/effects';
import { stopSubmit } from 'redux-form';

import { actions } from 'store/clientReducer';
import { setPaginationFor } from 'store/pagination-reducer';
import api from 'core/utils/api';
import * as notify from 'components/ui/Notify/store/actions';

const setClientsPagination = setPaginationFor('CLIENTS');

function* fetchClients(action) {
  const params = action.payload;
  try {
    const res = yield call(api.get, '/clients', { params });
    yield put(actions.fetchClientsSuccess(res.data.clients));
    yield put(setClientsPagination(res));
  } catch(err) {
    yield put(actions.fetchClientsFail(err.response.data.error))
  }
}

function* watchFetchClients() {
  yield takeLatest(actions.fetchClients().type, fetchClients)
}

function* fetchClient(action) {
  try {
    const res = yield call(api.get, `/clients/${action.payload}`)
    yield put(actions.fetchClientSuccess(res.data.client))
  } catch(err) {
    yield put(actions.fetchClientFail(err.response.data.error))
  }
}

function* watchFetchClient() {
  yield takeLatest(actions.fetchClient().type, fetchClient)
}

function* createClient(action) {
  try {
    const [client, historyPush] = action.payload;
    const res = yield call(api.post, '/clients', { client });
    yield put(notify.actions.success('Client was successfully created.'));
    const propertyId = res.data.client.properties[0].id;
    yield call(() => historyPush(`/tests/new?propertyId=${propertyId}`));
  } catch(err) {
    yield put(actions.createClientFail(err.response.data.error))
    yield put(stopSubmit('client', err.response.data.error.message))
  }
}

function* watchCreateClient() {
  yield takeLatest(actions.createClient().type, createClient)
}

function* updateClient(action) {
  const client = action.payload[0]
  try {
    yield call(api.put, `/clients/${client.id}`, { client })
    yield put(notify.actions.success('Client was successfully updated.'))
    yield call(action.payload[1])
  } catch(err) {
    yield put(actions.updateClientFail(err.response.data.error))
    yield put(stopSubmit('client', err.response.data.error.message))
  }
}

function* watchUpdateClient() {
  yield takeLatest(actions.updateClient().type, updateClient)
}

function* deleteClient(action) {
  try {
    const res = yield call(api.delete, `/clients/${action.payload}`);
    yield put(actions.deleteClientSuccess(res.data.client));
    yield put(notify.actions.success('Client was successfully deleted.'));
  } catch(err) {
    const { error } = err.response.data;
    yield put(actions.deleteClientFail(error));
    yield put(notify.actions.error(error.message));
  }
}

function* watchDeleteClient() {
  yield takeLatest(actions.deleteClient().type, deleteClient)
}

export default function* clientsSaga() {
  yield all([
    watchFetchClients(),
    watchFetchClient(),
    watchCreateClient(),
    watchUpdateClient(),
    watchDeleteClient(),
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/clientsSaga.js